import * as React from 'react';
import { DocumentViewer } from './DocumentViewer'
import { InvoiceModelEditor } from './InvoiceModelEditor'
import './css/style.css';
import { isNewUi } from '../../../redesign/uiMode';
import ModelSetupHeader from '../../../redesign/models/ModelSetupHeader';

export class InvoiceModelSetup extends React.Component {
	constructor(props) {
		super(props);

		this.state = {};

		this.passInvoiceModelEditorToSiblings = this.passInvoiceModelEditorToSiblings.bind(this);
	}

	passInvoiceModelEditorToSiblings(invoiceModelEditor) {
		this.setState({ invoiceModelEditor: invoiceModelEditor })
	}

	render() {
		var info = this.props.info;
		info.passInvoiceModelEditorToSiblings = this.passInvoiceModelEditorToSiblings
		info.invoiceModelEditor = this.state.invoiceModelEditor;

		// New UI (docs/ui_redesign/18-ux-review.md, R22): the editor's frame. A header says which model this is and has a
		// Close (the same props.onClose as Cancel); the columns, cards and buttons below are Classic's, restyled.
		if (isNewUi()) {
			return (
				<div className="apw2 apw2-ms">
					<ModelSetupHeader info={info} onClose={this.props.onClose} />
					<div className="body-container-wrapper">
						<div className="mainTable fullWidthTable">
							<div className="row-form">
								<DocumentViewer info={this.props.info} />
								<InvoiceModelEditor info={this.props.info} onClose={this.props.onClose} />
							</div>
						</div>
					</div>
				</div>
			);
		}

		return (
			<div>
				<h1 style={{ marginLeft: 15 }}>Invoice Model Setup</h1>
				<div className="body-container-wrapper">
					<div className="mainTable fullWidthTable">
						<div className="row-form">
							<DocumentViewer info={this.props.info} />
							<InvoiceModelEditor info={this.props.info} onClose={this.props.onClose} />
						</div>
					</div>
				</div>
			</div>
		);
	}
}